import sdl from '@jds/react-generated-sdl/JDSDatepickerViewButton';
import type { JDSDatepickerViewButtonProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSDatepickerViewButtonProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    disabled = false,
    selected = false,
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { disabled, selected, ...rest },
    'JDSDatepickerViewButton',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const DatepickerViewButton = withLogic(
  Component
) as React.FC<JDSDatepickerViewButtonProps> & { slotName?: string };

DatepickerViewButton.displayName = 'DatepickerViewButton';
DatepickerViewButton.slotName = 'jds_datepicker_view_button';

export { DatepickerViewButton, type JDSDatepickerViewButtonProps };
